export const RedirectIcon = () => {
    return (
        <svg id="open_in_new_black_24dp" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
            <path id="Path_205397" data-name="Path 205397" d="M0,0H18V18H0Z" fill="none" />
            <path id="Path_205398" data-name="Path 205398" d="M15,15H4.5V4.5H9.75V3H4.5A1.5,1.5,0,0,0,3,4.5V15a1.5,1.5,0,0,0,1.5,1.5H15A1.5,1.5,0,0,0,16.5,15V9.75H15ZM11.25,3V4.5h2.693L6.57,11.872,7.628,12.93,15,5.557V8.25h1.5V3Z" transform="translate(-0.75 -0.75)" fill="#1b5984" />
        </svg>
    )
}
